import React, { useEffect, useState } from "react";
import ModalOpen from "./ModalOpen";
import { useDispatch } from "react-redux";
import { waveflowModelList } from "../../../redux/reducer/waveFlow";
import { GettingAllModels } from "../../../allApi/api";
import { CardGrid, ModelList } from "./ModelShown";
import {
  Box,
  Button,
  Center,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  Text,
  VStack
} from "@chakra-ui/react";
import { TbBoxModel } from "react-icons/tb";
import search_icon from "../../../assets/waveflowmain/search_icon.png";
import grid_view from "../../../assets/waveflowmain/grid_view.png";
import list_view from "../../../assets/waveflowmain/list_view.png";
import FilterComponent from "./DropDown";
import { commonStyle } from "../../../styles/commonStyle";
import { clearModelFetch } from "../../../redux/reducer/toolsmodel";

function Models() {
  const [viewOfModelList, setViewOfModelList] = useState(true);
  const [loader, setLoader] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [allModels, setAllModels] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        const data = await GettingAllModels();
        const models = data?.models || [];
        setAllModels(models);
        dispatch(waveflowModelList(models));
        dispatch(clearModelFetch());
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleAddModel = (newModel) => {
    setAllModels((prev) => {
      const updated = [newModel, ...prev];
      dispatch(waveflowModelList(updated));
      dispatch(clearModelFetch());
      return updated;
    });
  };

  const handleDeleteModel = (modelId) => {
    setAllModels((prev) => {
      const updated = prev.filter((m) => m.id !== modelId);
      dispatch(waveflowModelList(updated));
      dispatch(clearModelFetch());
      return updated;
    });
  };

  const filteredModels = allModels.filter((item) => {
    const matchesFilter =
      selectedFilter === "All" ||
      item.client.toLowerCase() === selectedFilter.toLowerCase();
    const matchesSearch =
      item.client.toLowerCase().includes(searchInput.toLowerCase()) ||
      item.model_name.toLowerCase().includes(searchInput.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <Box w={"90%"} m={"auto"}>
      <Box mt={"10px"}>
        <Text fontWeight={500}>Model Hub</Text>
        <Text color={"rgba(108, 114, 117, 0.75)"}>
          Create model configurations that can be reused in your agents and workflows.
        </Text>
      </Box>

      <HStack w={"100%"} justifyContent={"space-between"} mt={4}>
        <HStack w="35%">
          <InputGroup size="sm" border={"transparent"}>
            <InputLeftElement pointerEvents="none">
              <Image src={search_icon} w={"25px"} />
            </InputLeftElement>
            <Input
              _placeholder={{ color: "rgba(108, 114, 117, 0.5)" }}
              placeholder="search"
              bg="gray.20"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </InputGroup>

          <FilterComponent
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />

          <Button
            variant="outline"
            size="sm"
            border={"none"}
            _hover={{ bg: "transparent" }}
            onClick={() => setViewOfModelList(!viewOfModelList)}
          >
            <HStack spacing={2}>
              <Image
                src={viewOfModelList ? list_view : grid_view}
                alt="Icon"
                boxSize="18px"
              />
              <Text fontSize={"12px"} color={"rgba(108, 114, 117, 0.5)"}>
                view
              </Text>
            </HStack>
          </Button>
        </HStack>

        <ModalOpen onAdd={handleAddModel} />
      </HStack>

      {loader && (
        <Center h="50vh">
          <Spinner size="xl" />
        </Center>
      )}

      {!loader && filteredModels.length > 0 && (
        <Box h={"70%"} overflowY="auto" sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}>
          {viewOfModelList ? (
            <CardGrid modelList={filteredModels} onDelete={handleDeleteModel} />
          ) : (
            <ModelList modelList={filteredModels} onDelete={handleDeleteModel} />
          )}
        </Box>
      )}

      {!loader && filteredModels.length === 0 && (
        <Box
          w="100%"
          minH="250px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="gray.50"
          p={6}
        >
          <VStack spacing={3}>
            <TbBoxModel size={50} color="#718096" />
            <Text fontWeight="bold" fontSize="lg" color="gray.700">
              No models found
            </Text>
          </VStack>
        </Box>
      )}
    </Box>
  );
}

export default Models;
